/* global console */

import { fetchWithRetry, checkAuthStatus, parseErrorResponse } from "../../utils";
import { buildApiUrl } from "../../config";
import { withCredentials } from "../../services/apiClient";
import type { TasksResult } from "./types";

export async function getUserTasks(userId: string): Promise<TasksResult> {
  try {
    const response = await fetchWithRetry(
      buildApiUrl(`/api/finster/tasks/${encodeURIComponent(userId)}`),
      withCredentials({ method: "GET" }),
      1,
      "TASKS"
    );

    checkAuthStatus(response);

    if (!response.ok) {
      const errorText = await parseErrorResponse(response);
      return { tasks: [], rawJson: errorText, error: `HTTP ${response.status}: ${errorText}` };
    }

    const rawJson = await response.text();
    const data = JSON.parse(rawJson);
    const tasks = Array.isArray(data) ? data : data.tasks || [];
    return { tasks, rawJson };
  } catch (error) {
    const msg = error instanceof Error ? error.message : String(error);
    console.error("[TASKS] Error:", msg);
    return { tasks: [], rawJson: "", error: msg };
  }
}

export async function getTaskOutput(
  userId: string,
  taskId: string,
  taskRunId: string
): Promise<{ data: unknown; error?: string }> {
  try {
    const path = `/api/finster/tasks/output/${encodeURIComponent(userId)}/${encodeURIComponent(taskId)}/${encodeURIComponent(taskRunId)}`;
    const response = await fetchWithRetry(
      buildApiUrl(path),
      withCredentials({ method: "GET" }),
      1,
      "TASK_OUTPUT"
    );

    checkAuthStatus(response);

    if (!response.ok) {
      const errorText = await parseErrorResponse(response);
      return { data: null, error: `HTTP ${response.status}: ${errorText}` };
    }

    return { data: await response.json() };
  } catch (error) {
    const msg = error instanceof Error ? error.message : String(error);
    console.error("[TASK_OUTPUT] Error:", msg);
    return { data: null, error: msg };
  }
}
